import React from 'react';
import PropTypes from 'prop-types';
import "./assets/navigation.scss";
import Navbar from './Navbar';
import FeedbackNotice from '../Common/Feedback/FeedbackNotice';

const PageContainer = ({ error, setError, isAdmin, children }) => {

    const navList = [{
        align: "top", items: [
            { name: 'Dashboard', href: '/dashboard', icon: 'bi-speedometer2', auth: true },
            { name: 'Portfolio Context', href: '/projects', icon: 'bi-kanban', auth: true },
            { name: 'Drafts', href: '/portfolios/drafts', icon: 'bi-folder2', auth: true },
            { name: 'Published', href: '/portfolios/published', icon: 'bi-folder2', auth: true },

        ]
    }, {
        align: "center", items: [
            { name: 'Admin Dashboard', href: '/admin', icon: 'bi-shield-lock', auth: true, admin: true },
            { name: 'Manage Users', href: '/admin/users', icon: 'bi-people', auth: true, admin: true },
        ]
    }, {
        align: "bottom", items: [
            { name: 'Privacy Policy', href: '/privacy-policy', icon: 'bi-shield-lock' },
            { name: 'Delete Account', href: '/settings/delete-account', icon: 'bi-person-x', auth: true },
        ]
    }];

    return (
        <div className="page-wrapper">
            <Navbar setError={setError} navList={navList} isAdmin={isAdmin} />

            <main className="main-content">
                <FeedbackNotice
                    message={error || ''}
                    variant="danger"
                    onDismiss={() => setError?.(null)}
                />

                <div className="container-fluid container-lg">
                    {children}
                </div>
            </main>
        </div>
    );
};

PageContainer.propTypes = {
    error: PropTypes.string,
    setError: PropTypes.func,
    isAdmin: PropTypes.bool,
    children: PropTypes.node
};

export default PageContainer;
